export class TimesheetSelectedCells
{
    startRow: number;
    endRow: number;
    startColumn: number;
    endColumn: number;

    isSingleCell()
    {
        return this.startRow === this.endRow && this.startColumn === this.endColumn;
    }

    static get(hot: Handsontable): TimesheetSelectedCells
    {
        const coords = hot.getSelectedLast();
        if (!coords || coords.length < 4)
        {
            return null;
        }

        const selectedCells = new TimesheetSelectedCells();
        selectedCells.startRow = Math.min(coords[0], coords[2]);
        selectedCells.endRow = Math.max(coords[0], coords[2]);
        selectedCells.startColumn = Math.min(coords[1], coords[3]);
        selectedCells.endColumn = Math.max(coords[1], coords[3]);
        return selectedCells;
    }
}
